var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 1,
    viewBox: "0 0 80 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0.5H-2.32458e-06",
    stroke: "#282828",
    strokeDasharray: "1 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorDash);
export default __webpack_public_path__ + "static/media/vector_dash.8147a486da1b52235f67cee8df4981ef.svg";
export { ForwardRef as ReactComponent };